import { render, staticRenderFns } from "./ContentSpreadsheet.vue?vue&type=template&id=fc8ed162&scoped=true&"
import script from "./ContentSpreadsheet.vue?vue&type=script&lang=js&"
export * from "./ContentSpreadsheet.vue?vue&type=script&lang=js&"
import style0 from "./ContentSpreadsheet.vue?vue&type=style&index=0&id=fc8ed162&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8ed162",
  null
  
)

export default component.exports